<div id="popup-modal" tabindex="-1" class="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-100">
  <div class="relative p-4 w-full max-w-md max-h-full">
    <div class="relative bg-white rounded-lg shadow-lg">
      <button type="button" class="absolute top-3 end-2.5 text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ms-auto inline-flex justify-center items-center" (click)="modalService.close()">
        <svg class="w-3 h-3" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 14">
          <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"/>
        </svg>
        <span class="sr-only">Close modal</span>
      </button>
      <div class="p-4 md:p-5 text-center" [ngClass]="{
        'text-blue-500': messageType() === ModalTypes.INFORMATION,
        'text-yellow-500': messageType() === ModalTypes.WARNING,
        'text-red-500': messageType() === ModalTypes.ERROR }">
        <svg class="mx-auto mb-4" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20" width="35" height="35">
          <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 11V6m0 8h.01M19 10a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"/>
        </svg>
        <ng-container *ngTemplateOutlet="message()"></ng-container>
        <button #okmodalbutton (click)="modalService.close()" class="btn btn-primary rounded btn-outline mt-4 text-primary p-1 px-10 rounded-lg">
          OK
        </button>
      </div>
    </div>
  </div>
</div>
  